import React from 'react';
import PageTitle from '../layout/PageTitle';

const RiskDisclosure: React.FC = () => {
  return (
    <div className="content">
      <div className="container mx-auto px-4 py-8 max-w-2xl">
        <PageTitle title="Risk Disclosure" />

        <div className="bg-brand-card/60 backdrop-blur-md border border-brand-border rounded-xl p-6 md:p-8 text-sm text-white/80 leading-relaxed space-y-5">
          <p>
            SentiHype is an informational service. We aggregate and present data — sentiment, metrics, and related analytics — for your reference only. This document explains how to treat that data.
          </p>

          <section>
            <h2 className="text-white font-semibold mb-1">Data only</h2>
            <p>
              We provide data, not recommendations or advice. Charts, scores, and other content are for information and research. Nothing on the service should be taken as a suggestion to buy, sell, or do anything with any asset.
            </p>
          </section>

          <section>
            <h2 className="text-white font-semibold mb-1">No guarantees</h2>
            <p>
              We do not warrant that our data is accurate, complete, or up to date. Data can be delayed, derived from third-party sources we do not control, or subject to errors. We strive for quality but make no guarantees.
            </p>
          </section>

          <section>
            <h2 className="text-white font-semibold mb-1">Third-party sources</h2>
            <p>
              Part of our data may come from or reference third parties (e.g. social platforms, public feeds). We do not control or endorse that content. Its availability and accuracy are outside our control.
            </p>
          </section>

          <section>
            <h2 className="text-white font-semibold mb-1">Your use</h2>
            <p>
              You are responsible for how you use our data. Verify important information elsewhere when needed. We are not liable for decisions you make based on the service.
            </p>
          </section>

          <p className="text-white/60 text-xs pt-1">
            For questions about this disclosure: <a href="https://t.me/sentihype" target="_blank" rel="noopener noreferrer" className="text-brand-cyan hover:underline">Telegram</a>, <a href="mailto:info@sentihype.com" className="text-brand-cyan hover:underline">info@sentihype.com</a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RiskDisclosure;
